
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30573',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30573",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54997",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8176",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11622",
  "I18n": "static-7.1643",
  "quartz": "static-1.7231",
  "quartz-config": "static-1.1009",
  "quartz-core": "static-1.6450",
  "react-dlb": "static-1.82",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "reselect": "static-3.7",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.836",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54984",
  "feedback-utils": "static-1.54988",
  "forms-embed-utils-lib": "static-1.4617",
  "forms-utils-lib": "static-1.12876",
  "foundations-assets": "static-1.5028",
  "foundations-components": "static-1.8240",
  "foundations-theming": "static-1.4591",
  "hub-http": "static-1.6375",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11929",
  "icons": "static-2.659",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.4030",
  "raven": "static-3.5925",
  "react": "static-7.188",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16848",
  "react-select-plus": "static-1.107",
  "react-utils": "static-2.5454",
  "react-virtualized": "static-2.101",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.490",
  "tinymce-plugins": "static-1.57892",
  "transmute": "static-2.85",
  "ui-images": "static-2.1195",
  "UIComponents": "static-3.8568",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3513",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3508",
  "quartz-webpack": "static-1.3455",
  "foundations-theming-specialty": "static-1.2307",
  "property-description-translator": "static-1.3994",
  "HeadJS": "static-2.775",
  "framer-motion": "static-1.74",
  "hs-test-utils-bend-plugin": "static-1.3287",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.224",
  "moment-timezone": "static-5.85",
  "jasmine": "static-4.4479",
  "jasmine-runner": "static-1.6611",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.850",
  "hubspotter-http": "static-1.4764",
  "mobile-manifest-mixins": "static-1.549",
  "module-federation": "static-1.28",
  "quartz-auth": "static-1.906",
  "quartz-head": "static-1.896",
  "quartz-i18n": "static-1.906",
  "quartz-routing": "static-1.661",
  "quartz-test": "static-1.906",
  "quartz-tracking": "static-1.610",
  "trellis-components": "static-1.2271",
  "ui-fonts": "static-1.884",
  "usage-tracker-container": "static-1.7496",
  "usage-tracker-core": "static-1.7356",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.159",
  "conversations-skeleton-state": "static-1.7402",
  "reference-resolvers": "static-1.8330",
  "sanitize-text": "static-1.8300",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10517",
  "sanitize": "static-1.4631",
  "outpost": "static-1.4322",
  "rpc-client-utils": "static-1.4814",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4509",
  "floating-ui": "static-1.59",
  "hs-story-utils": "static-1.9577",
  "react-aria": "static-1.68",
  "react-create-root-preference": "static-1.41",
  "tanstack-table": "static-1.57",
  "trellis-assets": "static-1.2252",
  "bend-plugin-foundations-theming": "static-1.3074",
  "foundations-theming-base": "static-1.3576",
  "stylex": "static-1.36",
  "hs-locale-management": "static-1.195",
  "csstype": "static-1.50",
  "web-vitals": "static-1.8",
  "ai-components-ui-library": "static-1.9339",
  "atom": "static-1.5229",
  "codemirror": "static-5.97",
  "content-assistance-lib": "static-1.7997",
  "ContentUtils": "static-1.68811",
  "data-token-picker": "static-1.16684",
  "file-manager-components": "static-1.24079",
  "FileManagerCore": "static-1.39578",
  "FileManagerLib": "static-1.39719",
  "frontend-preferences-client": "static-1.8081",
  "hub-http-contrib": "static-1.3198",
  "interframe": "static-3.4912",
  "layout-dnd-components": "static-1.12748",
  "layout-dnd-utils": "static-1.11723",
  "property-translator": "static-1.5550",
  "react-codemirror": "static-1.10782",
  "react-colorpicker": "static-2.10362",
  "reference-resolvers-lite": "static-1.8251",
  "rich-text-lib": "static-1.20103",
  "tinymce-data": "static-1.40863",
  "tinymce-themes": "static-1.56748",
  "ui-addon-emoji-picker": "static-1.10038",
  "ui-addon-sales-email": "static-1.5365",
  "ui-brand-identity-lib": "static-1.15848",
  "bender-build-tools": "static-1.3301",
  "hub-http-shared-msw-handlers": "static-1.10341",
  "hubspotter-http-shared-msw-handlers": "static-1.10339",
  "usage-tracker-session-replay": "static-1.5192",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "trellis-theming": "static-1.1101",
  "tanstack-virtual": "static-1.32",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.224",
  "chirp-fetch": "static-1.2042",
  "chatspot-core": "static-1.22060",
  "copilot-toolkit": "static-1.11527",
  "customer-data-objects-ui-components": "static-1.13184",
  "data-fetching-client": "static-1.9814",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4914",
  "ui-addon-video-player": "static-1.8859",
  "ui-coaching-tips": "static-1.28986",
  "usage-tracker": "static-1.7506",
  "cms-field-types": "static-1.4969",
  "content-icons-ui": "static-1.2272",
  "integrations-lib": "static-1.16642",
  "customer-data-objects": "static-1.7833",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1259",
  "apollo-link-hub-http": "static-2.4805",
  "apollo-stack-hubspot": "static-3.88",
  "graphql": "static-1.84",
  "immer": "static-1.33",
  "immerable": "static-1.4305",
  "ui-addon-iframeable": "static-1.9227",
  "video-components-external": "static-1.11788",
  "video-data-lib": "static-1.35446",
  "audio-components": "static-1.6154",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29588",
  "FileManagerImages": "static-1.37230",
  "foundations-components-legacy": "static-1.1265",
  "html-to-image": "static-1.56",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "salesImages": "static-1.528",
  "ui-universal-auth": "static-1.9163",
  "urlinator": "static-1.4688",
  "video-components": "static-1.13790",
  "video-embed": "static-1.36280",
  "ts-schema": "static-1.4195",
  "ContentData": "static-1.68886",
  "layout-data-lib": "static-1.10048",
  "react-dnd-compat": "static-1.4768",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1698",
  "external-options-client-types": "static-1.4240",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7049",
  "hs-promise-utils": "static-1.5748",
  "inbound-db-properties-service-client": "static-1.3960",
  "NamespacedHubStyle": "static-2.9167",
  "growth-onboarding-confetti": "static-1.3220",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11303",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5654",
  "magpie-types": "static-1.5114",
  "simple-logging-lib": "static-1.3202",
  "avatar-components": "static-1.2653",
  "customer-data-ui-utilities": "static-1.9977",
  "growth-onboarding-feedback-components": "static-1.6733",
  "flux-actions": "static-1.350",
  "hubspot-apollo-client": "static-1.5032",
  "integrations-error-boundary-lib": "static-1.14057",
  "integrations-tracking-lib": "static-1.5761",
  "laboratory-lib": "static-3.7306",
  "native-integrations-shared-strings": "static-1.7934",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10412",
  "unified-auth": "static-1.677",
  "breeze-engine-core": "static-1.537",
  "ably": "static-2.2",
  "highlight.js": "static-1.81",
  "navigation-messaging": "static-1.7723",
  "content-media-composition-data-lib": "static-1.12811",
  "content-media-compositions": "static-2.16818",
  "idb-keyval": "static-1.46",
  "media-bridge-lib": "static-1.19200",
  "unified-auth-core-lib": "static-1.959",
  "social-insights-client-types": "static-1.22469",
  "advanced-menus-core": "static-1.15388",
  "advanced-menus-lib": "static-1.12289",
  "ExportDialog": "static-6.10533",
  "ui-memberships-settings-lib": "static-1.34461",
  "conditional-properties-service-client": "static-1.3911",
  "crm-pipelines-api-client-types": "static-1.4251",
  "fdsr-migration-layer": "static-1.168",
  "framework-builder-read-service-client": "static-1.4119",
  "framework-data-schema-quick-fetch": "static-1.6954",
  "inbound-db-meta-service-client": "static-1.3701",
  "multi-currency-client-types": "static-1.3805",
  "persist-promise": "static-1.3855",
  "foundations-components-test-utils": "static-1.5723",
  "reactive-lib": "static-1.879",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.491",
  "universal-page-editor-lib": "static-1.3166",
  "adobe-sign-auth-lib": "static-1.123",
  "ads-unified-auth-lib": "static-1.602",
  "google-sheets-integration-lib": "static-1.689",
  "microsoft-drive-integration-lib": "static-1.856",
  "surveymonkey-integration-lib": "static-1.141",
  "slack-ui-library": "static-1.10552",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3884",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15387",
  "simple-menus-lib": "static-1.16904",
  "crm-record-cards-service-types": "static-1.3699",
  "location-customization-utils-lib": "static-1.9704",
  "react-flip-move": "static-1.73"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30573",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54997",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8176",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11622",
  "I18n": "/I18n/static-7.1643",
  "quartz": "/quartz/static-1.7231",
  "quartz-config": "/quartz-config/static-1.1009",
  "quartz-core": "/quartz-core/static-1.6450",
  "react-dlb": "/react-dlb/static-1.82",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reselect": "/reselect/static-3.7",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.836",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54984",
  "feedback-utils": "/feedback-utils/static-1.54988",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4617",
  "forms-utils-lib": "/forms-utils-lib/static-1.12876",
  "foundations-assets": "/foundations-assets/static-1.5028",
  "foundations-components": "/foundations-components/static-1.8240",
  "foundations-theming": "/foundations-theming/static-1.4591",
  "hub-http": "/hub-http/static-1.6375",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11929",
  "icons": "/icons/static-2.659",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.4030",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.188",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16848",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-utils": "/react-utils/static-2.5454",
  "react-virtualized": "/react-virtualized/static-2.101",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "tinymce-plugins": "/tinymce-plugins/static-1.57892",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1195",
  "UIComponents": "/UIComponents/static-3.8568",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3513",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3508",
  "quartz-webpack": "/quartz-webpack/static-1.3455",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2307",
  "property-description-translator": "/property-description-translator/static-1.3994",
  "HeadJS": "/HeadJS/static-2.775",
  "framer-motion": "/framer-motion/static-1.74",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3287",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.224",
  "moment-timezone": "/moment-timezone/static-5.85",
  "jasmine": "/jasmine/static-4.4479",
  "jasmine-runner": "/jasmine-runner/static-1.6611",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.850",
  "hubspotter-http": "/hubspotter-http/static-1.4764",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.549",
  "module-federation": "/module-federation/static-1.28",
  "quartz-auth": "/quartz-auth/static-1.906",
  "quartz-head": "/quartz-head/static-1.896",
  "quartz-i18n": "/quartz-i18n/static-1.906",
  "quartz-routing": "/quartz-routing/static-1.661",
  "quartz-test": "/quartz-test/static-1.906",
  "quartz-tracking": "/quartz-tracking/static-1.610",
  "trellis-components": "/trellis-components/static-1.2271",
  "ui-fonts": "/ui-fonts/static-1.884",
  "usage-tracker-container": "/usage-tracker-container/static-1.7496",
  "usage-tracker-core": "/usage-tracker-core/static-1.7356",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.159",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7402",
  "reference-resolvers": "/reference-resolvers/static-1.8330",
  "sanitize-text": "/sanitize-text/static-1.8300",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10517",
  "sanitize": "/sanitize/static-1.4631",
  "outpost": "/outpost/static-1.4322",
  "rpc-client-utils": "/rpc-client-utils/static-1.4814",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4509",
  "floating-ui": "/floating-ui/static-1.59",
  "hs-story-utils": "/hs-story-utils/static-1.9577",
  "react-aria": "/react-aria/static-1.68",
  "react-create-root-preference": "/react-create-root-preference/static-1.41",
  "tanstack-table": "/tanstack-table/static-1.57",
  "trellis-assets": "/trellis-assets/static-1.2252",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3074",
  "foundations-theming-base": "/foundations-theming-base/static-1.3576",
  "stylex": "/stylex/static-1.36",
  "hs-locale-management": "/hs-locale-management/static-1.195",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.8",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9339",
  "atom": "/atom/static-1.5229",
  "codemirror": "/codemirror/static-5.97",
  "content-assistance-lib": "/content-assistance-lib/static-1.7997",
  "ContentUtils": "/ContentUtils/static-1.68811",
  "data-token-picker": "/data-token-picker/static-1.16684",
  "file-manager-components": "/file-manager-components/static-1.24079",
  "FileManagerCore": "/FileManagerCore/static-1.39578",
  "FileManagerLib": "/FileManagerLib/static-1.39719",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8081",
  "hub-http-contrib": "/hub-http-contrib/static-1.3198",
  "interframe": "/interframe/static-3.4912",
  "layout-dnd-components": "/layout-dnd-components/static-1.12748",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11723",
  "property-translator": "/property-translator/static-1.5550",
  "react-codemirror": "/react-codemirror/static-1.10782",
  "react-colorpicker": "/react-colorpicker/static-2.10362",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8251",
  "rich-text-lib": "/rich-text-lib/static-1.20103",
  "tinymce-data": "/tinymce-data/static-1.40863",
  "tinymce-themes": "/tinymce-themes/static-1.56748",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10038",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5365",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15848",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10341",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10339",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5192",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "trellis-theming": "/trellis-theming/static-1.1101",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.224",
  "chirp-fetch": "/chirp-fetch/static-1.2042",
  "chatspot-core": "/chatspot-core/static-1.22060",
  "copilot-toolkit": "/copilot-toolkit/static-1.11527",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13184",
  "data-fetching-client": "/data-fetching-client/static-1.9814",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4914",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8859",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28986",
  "usage-tracker": "/usage-tracker/static-1.7506",
  "cms-field-types": "/cms-field-types/static-1.4969",
  "content-icons-ui": "/content-icons-ui/static-1.2272",
  "integrations-lib": "/integrations-lib/static-1.16642",
  "customer-data-objects": "/customer-data-objects/static-1.7833",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1259",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4805",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.88",
  "graphql": "/graphql/static-1.84",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4305",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9227",
  "video-components-external": "/video-components-external/static-1.11788",
  "video-data-lib": "/video-data-lib/static-1.35446",
  "audio-components": "/audio-components/static-1.6154",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29588",
  "FileManagerImages": "/FileManagerImages/static-1.37230",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1265",
  "html-to-image": "/html-to-image/static-1.56",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "salesImages": "/salesImages/static-1.528",
  "ui-universal-auth": "/ui-universal-auth/static-1.9163",
  "urlinator": "/urlinator/static-1.4688",
  "video-components": "/video-components/static-1.13790",
  "video-embed": "/video-embed/static-1.36280",
  "ts-schema": "/ts-schema/static-1.4195",
  "ContentData": "/ContentData/static-1.68886",
  "layout-data-lib": "/layout-data-lib/static-1.10048",
  "react-dnd-compat": "/react-dnd-compat/static-1.4768",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1698",
  "external-options-client-types": "/external-options-client-types/static-1.4240",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7049",
  "hs-promise-utils": "/hs-promise-utils/static-1.5748",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3960",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9167",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3220",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11303",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5654",
  "magpie-types": "/magpie-types/static-1.5114",
  "simple-logging-lib": "/simple-logging-lib/static-1.3202",
  "avatar-components": "/avatar-components/static-1.2653",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9977",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6733",
  "flux-actions": "/flux-actions/static-1.350",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5032",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14057",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5761",
  "laboratory-lib": "/laboratory-lib/static-3.7306",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7934",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10412",
  "unified-auth": "/unified-auth/static-1.677",
  "breeze-engine-core": "/breeze-engine-core/static-1.537",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.81",
  "navigation-messaging": "/navigation-messaging/static-1.7723",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12811",
  "content-media-compositions": "/content-media-compositions/static-2.16818",
  "idb-keyval": "/idb-keyval/static-1.46",
  "media-bridge-lib": "/media-bridge-lib/static-1.19200",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.959",
  "social-insights-client-types": "/social-insights-client-types/static-1.22469",
  "advanced-menus-core": "/advanced-menus-core/static-1.15388",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12289",
  "ExportDialog": "/ExportDialog/static-6.10533",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34461",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3911",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4251",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.168",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4119",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6954",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3701",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3805",
  "persist-promise": "/persist-promise/static-1.3855",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5723",
  "reactive-lib": "/reactive-lib/static-1.879",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.491",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3166",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.123",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.602",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.689",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.856",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.141",
  "slack-ui-library": "/slack-ui-library/static-1.10552",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3884",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15387",
  "simple-menus-lib": "/simple-menus-lib/static-1.16904",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3699",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9704",
  "react-flip-move": "/react-flip-move/static-1.73"
}
};
